import { POSA_FORMAT } from "@tootsweet/model/lottery/POSAType";

export const BLEED = 0;

export function getDimensionsForFormat(format: POSA_FORMAT): [number, number] {
  switch (format) {
    case "flyer_a5":
      return [148 + BLEED, 210 + BLEED];

    case "flyer_a6":
      return [105 + BLEED, 148 + BLEED];

    // case "a4":
    // return [210 + BLEED, 297 + BLEED];

    case "stickers10x10":
      return [100 + BLEED, 100 + BLEED];

    case "stickers_dome":
      return [75 + BLEED, 75 + BLEED];

    case "a_long":
      return [210 + BLEED, 74 + BLEED];

    case "online-ig-story":
      return [1080, 1920];

    case "online-ig-post":
      return [1200, 1200];

    default:
      return [1080, 1920];
  }
}
